//============================================================================
// Name        : allocations.ts
// Purpose     : Implement dynamic logic for SO allcations
// Created     : 2020-03-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../../index";

class MfSoAllocations {
    init() {
        $("select").select2({
            minimumResultsForSearch: -1,
            width: "100%"
        });

        $("#rememberPrinter").on("change", this.saveSelectedPrinter);
        this.restoredSavedSettings();
    }

    saveSelectedPrinter() {
        $("#printer").on("change", this.saveSelectedPrinter);
        if ($("#rememberPrinter").is(":checked")) {
            localStorage.setItem("selectedPrinterId", $("#printer").val().toString());
        }
        else {
            localStorage.removeItem("selectedPrinterId");
        }
    }

    restoredSavedSettings() {
        const selectedPrinterId = localStorage.getItem("selectedPrinterId");

        if (selectedPrinterId) {
            $("#printer").val(selectedPrinterId);
            $("#printer").trigger("change");
            $("#rememberPrinter").prop("checked", "checked");
        }
    }
}

export function LoadPage() {
    InitPage("so_processes allocation", () => {
        const soAllocations = new MfSoAllocations();
        soAllocations.init();
    });
}
